import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Presentation } from "@/components/landing/Presentation";
import { Services } from "@/components/landing/Services";
import { Advantages } from "@/components/landing/Advantages";
import { AvantApres } from "@/components/landing/AvantApres";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-white text-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Presentation />
        <Services />
        <Advantages />
        <AvantApres />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
